import {defineAsyncComponent} from 'vue';

// Thiết lập vai trò quyền hạn
const roleDetail = defineAsyncComponent(() => import('@/views/system/role/RoleDetail.vue'));
const setRolePopup = defineAsyncComponent(() => import('@/views/system/role/SetRolePopup.vue'));
const pandaRolePage = defineAsyncComponent(() => import('@/views/system/role/PandaRolePage.vue'));
const userManagementDetail = defineAsyncComponent(() =>
  import('@/views/system/usermanagement/UserManagementDetail.vue'),
);
const userManagementForUnitDetail = defineAsyncComponent(() =>
  import('@/views/system/usermanagement/UserManagementForUnitDetail.vue'),
);

// Quản lý dữ liệu
const convertDataHelpPopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/ConvertDataHelpPopup.vue'),
);
const popupConfirmDelete = defineAsyncComponent(() => import('@/views/system/dataManagement/ConfirmDeletePopup.vue'));
const renameDataPopup = defineAsyncComponent(() => import('@/views/system/dataManagement/RenameDataPopup.vue'));
const backupDataPopup = defineAsyncComponent(() => import('@/views/system/dataManagement/BackupDataPopup.vue'));
const overLimitBackupPopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/OverLimitBackupPopup.vue'),
);
const backupRestoreProcessPopupX = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/BackupRestoreProcessPopupX.vue'),
);
const restoreDataPopup = defineAsyncComponent(() => import('@/views/system/dataManagement/RestoreDataPopup.vue'));
const dataInformationPopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/DataInformationPopup.vue'),
);

const chooseTenantDatabasePopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/ChooseTenantDatabasePopup.vue'),
);

// Tách dữ liệu theo Thông tư 107/2026/TT-BTC
const updateCircularPopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/updateCircular/UpdateCircularPopup.vue'),
);

// Khóa sổ
const ClosingLedgerPopup = defineAsyncComponent(() => import('@/views/system/closingLedger/ClosingLedgerPopup.vue'));

const HandleUnpostedVouchersPopup = defineAsyncComponent(() =>
  import('@/views/system/closingLedger/HandleUnpostedVouchersPopup.vue'),
);

const ChangePostedDatePopup = defineAsyncComponent(() =>
  import('@/views/system/closingLedger/ChangePostedDatePopup.vue'),
);

const ImpossiblePostedVouchersPopup = defineAsyncComponent(() =>
  import('@/views/system/closingLedger/ImpossiblePostedVouchersPopup.vue'),
);

const ReopenLedgerPopup = defineAsyncComponent(() => import('@/views/system/closingLedger/ReopenLedgerPopup.vue'));

const ResultConvert = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/resultConvert/ResultConvert.vue'),
);

const CompareResultPopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/CompareResultPopup.vue'),
);

const CompareNotErrorPopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/popup/CompareNotErrorPopup.vue'),
);
const CreateDataPrevYearProcessPopup = defineAsyncComponent(() =>
  import('@/views/system/dataManagement/createDataPrevYear/CreateDataPrevYearProcess.vue'),
);

const SearchVoucherPopup = defineAsyncComponent(() => import('@/views/system/searchVoucher/SearchVoucherPopup.vue'));

// Báo cáo nhanh
const QuickReportPopup = defineAsyncComponent(() => import('@/views/quickReport/QuickReportPopup.vue'));
const SaveQuickReportTemplatePopup = defineAsyncComponent(() =>
  import('@/views/quickReport/SaveQuickReportTemplatePopup.vue'),
);
const QuickReportTemplateListPopup = defineAsyncComponent(() =>
  import('@/views/quickReport/QuickReportTemplateListPopup.vue'),
);
// Nhập khẩu nhanh
const ImportChequeIssue = defineAsyncComponent(() =>
  import('@/views/dictionary/importChequeIssue/ImportChequeIssue.vue'),
);
// Thông tin đơn vị
const CompanyInfoPopup = defineAsyncComponent(() => import('@/views/system/companyInfo/CompanyInfo.vue'));

// Thiết lập chữ ký số
const SignReportSetting = defineAsyncComponent(() => import('@/views/system/signingSetting/SignReportSetting.vue'));
const SignSettingNoUSBPopup = defineAsyncComponent(() =>
  import('@/views/system/signingSetting/SignSettingNoUSBPopup.vue'),
);
const SettingEsign = defineAsyncComponent(() => import('@/views/system/esignSetting/SettingEsign.vue'));
const ChooseEsignCertPopup = defineAsyncComponent(() => import('@/views/system/esignSetting/ChooseEsignCertPopup.vue'));
export function registerSystem(app) {
  app.component('RoleDetail', roleDetail);
  app.component('SetRolePopup', setRolePopup);
  app.component('PandaRolePage', pandaRolePage);
  app.component('UserManagementDetail', userManagementDetail);
  app.component('UserManagementForUnitDetail', userManagementForUnitDetail);
  app.component('ConfirmDeletePopup', popupConfirmDelete);
  app.component('ConvertDataHelpPopup', convertDataHelpPopup);
  app.component('RenameDataPopup', renameDataPopup);
  app.component('BackupDataPopup', backupDataPopup);
  app.component('OverLimitBackupPopup', overLimitBackupPopup);
  app.component('BackupRestoreProcessPopupX', backupRestoreProcessPopupX);
  app.component('RestoreDataPopup', restoreDataPopup);
  app.component('DataInformationPopup', dataInformationPopup);
  app.component('ChooseTenantDatabasePopup', chooseTenantDatabasePopup);
  app.component('UpdateCircularPopup', updateCircularPopup);

  app.component('ClosingLedgerPopup', ClosingLedgerPopup);
  app.component('HandleUnpostedVouchersPopup', HandleUnpostedVouchersPopup);
  app.component('ChangePostedDatePopup', ChangePostedDatePopup);
  app.component('ImpossiblePostedVouchersPopup', ImpossiblePostedVouchersPopup);
  app.component('ReopenLedgerPopup', ReopenLedgerPopup);
  app.component('CompanyInfo', CompanyInfoPopup);
  app.component('ResultConvert', ResultConvert);
  app.component('CompareResultPopup', CompareResultPopup);
  app.component('CompareNotErrorPopup', CompareNotErrorPopup);
  app.component('CreateDataPrevYearProcessPopup', CreateDataPrevYearProcessPopup);
  app.component('SearchVoucherPopup', SearchVoucherPopup);
  app.component('QuickReportPopup', QuickReportPopup);
  app.component('SaveQuickReportTemplatePopup', SaveQuickReportTemplatePopup);
  app.component('QuickReportTemplateListPopup', QuickReportTemplateListPopup);

  app.component('ImportChequeIssue', ImportChequeIssue);
  app.component('SignReportSetting', SignReportSetting);
  app.component('SignSettingNoUSBPopup', SignSettingNoUSBPopup);
  app.component('SettingEsign', SettingEsign);
  app.component('ChooseEsignCertPopup', ChooseEsignCertPopup);
}
